// "Danh sách | Dự án" toggle for the property list page. Groups units by
// building (project) or shows the flat unit list. State lives in `?group`
// (absent = list), so the choice survives refresh and is shareable.

import { useSearchParams } from "react-router";

import { cn } from "@/lib/utils";

type GroupMode = "list" | "project";

const OPTIONS: ReadonlyArray<{ value: GroupMode; label: string }> = [
  { value: "list", label: "Danh sách" },
  { value: "project", label: "Dự án" },
];

export function PropertyGroupToggle({ className }: { className?: string }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const value: GroupMode =
    searchParams.get("group") === "project" ? "project" : "list";

  const setValue = (next: GroupMode) => {
    if (next === value) return;
    setSearchParams(
      (prev) => {
        const out = new URLSearchParams(prev);
        if (next === "project") out.set("group", "project");
        else out.delete("group");
        out.delete("page");
        out.delete("building"); // leave any drill-down
        return out;
      },
      { replace: true },
    );
  };

  return (
    <div
      role="tablist"
      aria-label="Nhóm hiển thị"
      className={cn(
        "inline-flex items-center gap-1 rounded-[10px] border border-border bg-background p-[3px]",
        className,
      )}
    >
      {OPTIONS.map((o) => {
        const isActive = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => setValue(o.value)}
            className={cn(
              "rounded-[6px] px-2.5 py-1 text-[12px] transition-colors focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none",
              isActive
                ? "bg-foreground font-semibold text-background"
                : "font-medium text-muted-foreground hover:text-foreground",
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
